
    import * as qwest from 'qwest/qwest.min.js';
    window.qwest = qwest;
  import '/drkiq/app/javascript/components_common/close-alert.js';import '/drkiq/app/javascript/components_common/detect-device.js';import '/drkiq/app/javascript/components_common/menu-animation.js';import '/drkiq/app/javascript/components_common/page-router.js';



// WEBPACK FOOTER //
// ./app/javascript/packs/gsk-minimal.js.erb